import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SvgIcon from '../icons/SvgIcon';

const Caret = ({ isOpen }) => {
    const icon = SvgIcon.ARROW_DOWN;

    return (
        <SvgIcon
            className={classNames('Caret', {
                'Caret--open': isOpen
            })}
            icon={icon}
        />
    );
};

Caret.propTypes = {
    isOpen: PropTypes.bool,
};

export default Caret;
